<template>
    <div class="frontend-style wireCoating" :style="{backgroundImage:'url('+Images.Home.banner.bg+')'}">
        <ul>
            <li class="margin-right" :style="{backgroundImage:'url('+Logo.honchiBg+')'}">
                <div>
                    <div>
                        <img :src="Logo.honchi" alt="">
                        <p>{{$t("home.branding.honchi")}}</p>
                    </div>
                    <button @click="goPage('gbei2OTYevrQBYHPTtF6')">{{$t("home.branding.honchi_button")}}</button>
                </div>
            </li>
            <li :style="{backgroundImage:'url('+Logo.yentekBg+')'}">
                <div>
                    <div>
                        <img :src="Logo.yentek" alt="">
                        <p>{{$t("home.branding.yentek")}}</p>
                    </div>
                    <button @click="goPage('E6xxLD026ormxXqfBZiu')">{{$t("home.branding.yentek_button")}}</button>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import HongChi_logo_website from '@/assets/images/HongChi_logo_website.png'
import HonChiBg from '@/assets/images/Manu_F_.jpg'
import yentek_logo from '@/assets/images/yentek_logo.svg'
import yentek_bg from '@/assets/images/yentek_banner_cut.jpg'
export default {
    name:'WireCoating',
    data() {
        return {
            Logo:{
                honchi:HongChi_logo_website,
                honchiBg:HonChiBg,
                yentek:yentek_logo,
                yentekBg:yentek_bg
            }
        }
    },
    computed: {
        ...mapState('frontend',[
            'Images'
        ])
    },
    methods: {
         ...mapActions('frontend',[
			'changeCategory'
		]),
        goPage(cate){
            this.changeCategory({id:cate})
            this.$router.push({path:'/products',query:{id:cate}})
        }
    }
}
</script>